export default __webpack_public_path__ + "static/media/freedom_gatia_logotype_preview.7659be03.png";